<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf"><a class="page" id="pv"></a>For the people of <i>this</i> generation, looking uncomfortably to the world they inherit</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// barretthedefiant-0005.vue?3cebe3e8